'use strict';
import {epics as reduxEpics} from '../redux';


export const epics = [
  ...reduxEpics,
];



// WEBPACK FOOTER //
// ./src/js/user-profile/epics/index.js